import { definePresentationResponse } from "../presenter"

export interface UnsavedChangesRequest {
  /** Overrides the localized title. */
  readonly title?: string
  /** Overrides the localized question. */
  readonly message?: string
  /** False when the changes cannot be saved from here, so only Discard and Cancel are offered. Default: true. */
  readonly canSave?: boolean
}

/** Save and then leave, leave without the changes, or stay. */
export type UnsavedChangesChoice = "save" | "discard" | "cancel"

/** Asks what to do with unsaved changes before leaving. Dismissing the dialog resolves to "cancel". */
export const unsavedChangesResponse = definePresentationResponse<UnsavedChangesRequest, UnsavedChangesChoice>({
  type: "UnsavedChanges",
})
